// extracted by mini-css-extract-plugin
export default {"preparedForImg":"cover_preparedForImg__nJ+AV","imgFit":"cover_imgFit__CibcC"};